export default function(el, prefix, host) {
  var id;
  if(host){
    if(host.$idCount===undefined){
      host.$idCount = 0;
    }else{
      host.$idCount++;
    }

    id=host.$idCount;
  }else{
    id=0;
    while (document.getElementById(prefix + id)) {
      id++;
    }
  }

  id = prefix + id;
  el.setAttribute('id', id);
  return id;
}
